'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp2; // import * as generatePath from 'react-router-dom/generatePath';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _reactRouterDom = require('react-router-dom');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  wrapper: {},
  row: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: 'center',
    listStyle: "none",
    // margin: 0,
    padding: 0
  },
  active: {
    background: "#ddd"
  },
  control: {},
  link: {
    padding: "3px 6px",
    border: "1px solid #ddd",
    marginLeft: 3,
    marginRight: 3,
    textDecoration: "none",
    "&:hover": {
      background: "#dfdfdf"
    } // avatar: {
    //   margin: 10,
    //   textDecoration: "none",
    // },
    // smallAvatar: {
    //   width: 30,
    //   height: 30,
    // },
    // bigAvatar: {
    //   width: 120,
    //   height: 120,
    // },

  }
};
var Pagination = exports.Pagination = (_temp2 = _class = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.getNewLocation = function (page) {
      var router = _this.context.router;
      var pageVariable = _this.props.pageVariable; // return '/';

      if (!router) {
        return null;
      }

      var history = router.history;
      var location = history.location;
      var pathname = location.pathname,
          search = location.search; // const newHref = `${pathname}`;

      var uri = new _urijs2.default('' + pathname + search);
      var query = uri.query(true); // let search
      // if(page > 1){
      //   search = search + `&page=${page}`;
      // }
      // else{
      // }

      Object.assign(query, _defineProperty({}, pageVariable, page > 1 ? page : undefined));
      uri.query(query);
      return uri.resource();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pagination, [{
    key: 'getPage',
    value: function getPage() {
      var page = this.props.page; // const page = this.props[pageVariable];

      return parseInt(page) || 1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          limit = _props.limit,
          total = _props.total,
          rowProps = _props.rowProps,
          pageVariable = _props.pageVariable,
          other = _objectWithoutProperties(_props, ['classes', 'limit', 'total', 'rowProps', 'pageVariable']);

      var page = this.getPage();

      if (!page || !limit || !total) {
        return null;
      }

      var pages = Math.ceil(total / limit);

      if (pages < 2) {
        return null;
      }

      var rowClass = classes.row,
          wrapperClass = classes.wrapper,
          controlClass = classes.control,
          linkClass = classes.link,
          activeClass = classes.active;
      var rows = [];

      if (page > 1) {
        var href = this.getNewLocation(1);
        var href = this.getNewLocation(page - 1);
        rows.push(_react2.default.createElement('li', {
          key: 'page-1-0',
          className: controlClass
        }, _react2.default.createElement(_reactRouterDom.Link, {
          to: href,
          href: href,
          className: linkClass
        }, '\xAB')));
      }

      var lstr = false;
      var rstr = false;

      for (var i = 1; i <= pages; i++) {
        if (page > 2 && i < page - 1 && i > 1 || pages - page > 3 && i > page + 1 && i < pages - 1) {
          if (!lstr && i > 1 && i < page) {
            rows.push(_react2.default.createElement('li', {
              key: i,
              className: controlClass
            }, _react2.default.createElement('span', null, '...')));
            lstr = true;
          }

          if (!rstr && i > page && i < pages) {
            rows.push(_react2.default.createElement('li', {
              key: i,
              className: controlClass
            }, _react2.default.createElement('span', null, '...')));
            rstr = true;
          }
        } else {
          var href = this.getNewLocation(i);
          rows.push(_react2.default.createElement('li', {
            key: i,
            className: controlClass
          }, _react2.default.createElement(_reactRouterDom.Link, {
            to: href,
            href: href,
            className: [linkClass, i === page ? activeClass : null].join(" ")
          }, i)));
        }
      }

      if (page < pages) {
        var href = this.getNewLocation(page + 1);
        rows.push(_react2.default.createElement('li', {
          key: 'page-' + pages + '-0',
          className: controlClass
        }, _react2.default.createElement(_reactRouterDom.Link, {
          to: href,
          href: href,
          className: linkClass
        }, '\xBB')));
      }

      return _react2.default.createElement('div', _extends({
        className: [wrapperClass, "Pagination--root"].join(" ")
      }, other), _react2.default.createElement('ul', _extends({
        className: rowClass
      }, rowProps), rows));
    }
  }]);

  return Pagination;
}(_react.Component), _class.propTypes = {
  // prop: PropTypes
  classes: _propTypes2.default.object.isRequired,
  limit: _propTypes2.default.number.isRequired,
  // page: PropTypes.number.isRequired,
  total: _propTypes2.default.number.isRequired,
  pageVariable: _propTypes2.default.string.isRequired,
  rowProps: _propTypes2.default.object
}, _class.defaultProps = {
  pageVariable: "page"
}, _class.contextTypes = {
  router: _propTypes2.default.object.isRequired
}, _temp2);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(Pagination, props);
});